import { LiveningIcpFormValues } from "../../types/LiveningIcpFormValues";
import { NewConnectionFormValues } from "../../types/NewConnectionFormValues";
import { DisconnectionFormValues } from "../../types/DisconnectionFormValues";
import { v4 as uuid } from "uuid";
import moment from "moment/moment";

export const setTransactionDetails = (
  values:
    | DisconnectionFormValues
    | LiveningIcpFormValues
    | NewConnectionFormValues,
): void => {
  if (!values.transactionKey) {
    values.transactionKey = uuid();
    values.transactionDateTime = moment()
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  }
};

export const clearTransactionDetails = (
  values:
    | DisconnectionFormValues
    | LiveningIcpFormValues
    | NewConnectionFormValues,
): void => {
  values.transactionKey = undefined;
  values.transactionDateTime = undefined;
};
